import { genId } from "../../utils"

export class LanguageCategory{
  constructor(data){
    Object.assign(this, data)
    this._id = data._id || genId()
    // this._createdBy = data._createdBy
    // this._modifiedBy = data._modifiedBy
    // this.modified = data.modified
    // this.type = data.type
    this.rel_id = data.rel_id || genId()
    this._changed = data._changed || false
  }

 

  getDataId(){
    return this[this.getTypeAddress()]
  }

  getType(){
    return this.type
  }

  static getTypeAddress(typeClass){
    return `_${typeClass.getTypeDir()}`
  }

  static getFormData(typeClass, subObj){
    let formKeys = typeClass.getFormKeys()
    let obj = {}
    for (let key of formKeys) obj[key] = subObj[key]

    return obj
  }

  static getParentAddress(SubClass){
    return `_${SubClass.getParentKey()}`
  }

  getChildRef(type, child, source){
    let currentRef = source[type].find((itm)=>(
      (itm[itm.getTypeAddress()] === child._id && this.getDataId() === itm[this.getTypeAddress()])
    ))
    return currentRef
    // return this.getDataId() === 

  }

  static getMongooseSchema(mongoose, Schema, subSchema, subType){
    let data = {
      ...subSchema,
      _createdBy: {type: mongoose.ObjectId, ref: 'User'},
      _modifiedBy: {type: mongoose.ObjectId, ref: 'User'},
      created: {type: Date, default: Date.now},
      modified: {type: Date},
      content: {type: String},
      _name: {type:String}
    }
    // console.log('schemaData before sending', subType, data)
    return new Schema(data, {
      toObject: { virtuals: true, getters:true},
      toJSON: { virtuals: true, getters:true}
    })
  }



  static constructFromDBData(data, type){
    let conData = {
      ...data[`_${type}`],
      ...data,
      [`_${type}`]: data[`_${type}`]._id
    }
    return conData

  }
}